import { useContext } from "react";

import UserUpdateContext from "../context/UserUpdateContext";

const useUpdateUser = () => useContext(UserUpdateContext);

export default useUpdateUser;
